import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a9a80ee2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "input-container w-100" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dollar-sign" }, "$", -1))
const _hoisted_3 = {
  key: 1,
  class: "text-red"
}

import { requiredRule } from "@/utils/rules";
import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CurrencyInput',
  props: {
  modelValue: Number || null || undefined,
  label: { type: String, default: "" },
  icon: String,
  rules: null,
  required: Boolean,
  inputType: { type: String, default: "text" },
},
  emits: ["update:modelValue"],
  setup(__props, { emit }) {

const props = __props;





const value = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
});

const rules = computed(() =>
  props.required ? [...(props.rules || []), requiredRule] : props.rules
);
function handleInput(event: any) {
  const inputValue = parseFloat(event.target.value);
  if (isNaN(inputValue) || inputValue < 0) {
    event.target.value = "";
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_input = _resolveComponent("v-input")!

  return (_openBlock(), _createBlock(_component_v_input, {
    "model-value": value.value,
    rules: rules.value
  }, {
    default: _withCtx(({ isValid }) => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _withDirectives(_createElementVNode("input", {
          onblur: "this.value = parseFloat(this.value).toFixed(2);",
          type: "number",
          step: "0.01",
          min: "0",
          onInput: _cache[0] || (_cache[0] = ($event: any) => (handleInput($event))),
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((value).value = $event)),
          class: _normalizeClass(`w-100 px-2 bg-gray pb-1 pt-4 ${
            isValid.value === false ? 'error' : ''
          }`),
          required: ""
        }, null, 34), [
          [_vModelText, value.value]
        ]),
        _createElementVNode("label", null, [
          (__props.icon)
            ? (_openBlock(), _createBlock(_component_v_icon, {
                key: 0,
                size: "24",
                class: _normalizeClass(`icon mdi ${__props.icon}`)
              }, null, 8, ["class"]))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(__props.label) + " ", 1),
          (__props.required)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, "*"))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    message: _withCtx(({ message }) => [
      _createVNode(_component_v_icon, {
        size: "12",
        class: "mdi mdi-alert-circle-outline"
      }),
      _createTextVNode(" " + _toDisplayString(message), 1)
    ]),
    _: 1
  }, 8, ["model-value", "rules"]))
}
}

})